import { ClaimsContainer } from '../containers/Claims'

/**
 * The Claims page.
 */
const ClaimsPage = () => {
  return <ClaimsContainer />
}

export default ClaimsPage
